import store from 'js/store';
import * as staticLocalizedText from 'js/constants/text';
import { LANGUAGE_CODE_SPANISH as LANGUAGE_DEFAULT } from 'js/constants/localization';
export function getCurrentLanguage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : store.getState();
  return state.localization.currentLanguage;
}
export function getBrowserLanguage() {
  return window.navigator.languages ? window.navigator.languages[0] : window.navigator.userLanguage || window.navigator.language;
} // TODO: do we need this?

export function stripLanguageCountry(language) {
  return language.substr(0, 2);
}
export function getBrowserLanguageWithoutCountry() {
  return stripLanguageCountry(getBrowserLanguage());
}
export function mapLocalizationObjectToLocalizedText(localizationObject) {
  var desiredLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentLanguage();
  return localizationObject[desiredLanguage] || localizationObject[LANGUAGE_DEFAULT] || // TODO: this last part should not be necessary - we need spanish translations for everything in text.js
  localizationObject[Object.keys(localizationObject)[0]];
}
export function mapTextVariableNameToStaticLocalizedText(textVariableName, desiredLanguage) {
  var localizationObject = staticLocalizedText[textVariableName];
  if (!localizationObject) throw new Error("Static text not found with variable name ".concat(textVariableName));
  return mapLocalizationObjectToLocalizedText(localizationObject, desiredLanguage);
}